import { apiHelper } from '@/util'

export const tiktokPixelService = {
  getTiktokPixels
}

//API urls
const TIKTOK = {
  TIKTOK: 'tiktok',
  GET_PIXELS: 'get-pixel'
}

function getTiktokPixels() {
  return apiHelper().get(`${TIKTOK.TIKTOK}/${TIKTOK.GET_PIXELS}`)
}
